import React from "react";
import { Box, styled, Typography } from "@mui/material";
import { useIsMobile } from "../../../../../hooks/responsive";
import { useOdysseeTheme } from "../../../../../context/odysseeTheme/OdysseeThemeProvider";

const CardContainer = styled(Box)(() => ({
    background: "linear-gradient(180deg, rgba(74, 54, 84, 0.5) 0%, rgba(45, 31, 61, 0.5) 50%, rgba(26, 20, 40, 0.5) 100%)",
    borderRadius: 20,
    overflow: "hidden",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
    width: 300,
    maxWidth: "100%",
    "&:hover": {
        transform: "translateY(-4px)",
        boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
    },
    "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "radial-gradient(ellipse at center top, rgba(139, 90, 120, 0.4) 0%, transparent 60%)",
        pointerEvents: "none",
    },
}));

const IntervenantImage = styled(Box)(() => ({
    position: "absolute",
    top: 0,
    height: "100%",
    overflow: "hidden",
    zIndex: 1,
    "& img": {
        width: "100%",
        height: "100%",
        objectFit: "cover",
    },
}));

const ActionButton = styled(Box)(() => ({
    background: "rgba(255, 255, 255, 0.15)",
    border: "1px solid rgba(255, 255, 255, 0.3)",
    borderRadius: 30,
    padding: "12px 32px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    marginTop: 24,
    "&:hover": {
        background: "rgba(255, 255, 255, 0.25)",
        borderColor: "rgba(255, 255, 255, 0.5)",
    },
}));

const ContentOverlay = styled(Box)(() => ({
    background: "linear-gradient(180deg, #170F21 0%, rgba(23, 15, 33, 0.3) 100%)",
    position: "relative",
    zIndex: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingBottom: "20px",
    paddingLeft: "20px",
    paddingRight: "20px",
    width: "100%",
}));

const LiveCard = ({ webinaire, isPast = false, onPlayClick }) => {
    const isMobile = useIsMobile();
    const firstIntervenant = webinaire?.intervenants?.[0];

    const [titleColor, contentColor] = useOdysseeTheme("card", [
        "header.title",
        "header.content",
    ]);

    const handleClick = () => {
        if (onPlayClick) {
            onPlayClick();
            return;
        }
        if (webinaire?.link) {
            window.open(webinaire.link, "_blank");
        }
    };

    return (
        <CardContainer>
            <Box sx={{
                position: "relative", width: "100%", display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-end",
                maxHeight: "350px",
                aspectRatio: "10 / 15",
            }}>
                <IntervenantImage>
                    <img
                        src={firstIntervenant.image}
                        alt={`${firstIntervenant.prenom} ${firstIntervenant.nom}`}
                    />
                </IntervenantImage>
                <Box sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 1,
                    background: "linear-gradient(180deg, rgba(23, 15, 33, 0.3) 50%, #170F21 100%)",
                }}>

                </Box>
                {firstIntervenant && (
                    <Typography
                        color={titleColor || "#ffffff"}
                        fontFamily="Branding SemiBold"
                        fontWeight={500}
                        fontSize={20}
                        textAlign="left"
                        ml={2.5}
                        mb={2}
                        sx={{ position: "relative", zIndex: 2 }}
                    >
                        {firstIntervenant.prenom} {firstIntervenant.nom}
                    </Typography>
                )}
            </Box>
            <ContentOverlay>
                <Typography
                    color={titleColor || "#ffffff"}
                    fontFamily="Branding Bold"
                    fontWeight={400}
                    width="100%"
                    fontSize={25}
                    lineHeight={1.2}
                    textAlign="left"
                >
                    {webinaire?.title}
                </Typography>
                <ActionButton onClick={handleClick}>
                    <Typography
                        color={titleColor || "#ffffff"}
                        fontFamily="Branding"
                        fontWeight={600}
                        fontSize={15}
                    >
                        {isPast ? "Revoir le webinaire" : "Accéder au webinaire"}
                    </Typography>
                </ActionButton>
            </ContentOverlay>
        </CardContainer>
    );
};

export default LiveCard;

